import type { ReactElement } from "react";

import { ContactsPerCompanyLimitInput } from "app/pages/sales-intelligence/common-components/contacts-per-company-limit-input/ContactsPerCompanyLimitInput";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";

import type FindContactLimitResultsFilter from "../../../models/ContactLimitResultsFilter/ContactLimitResultsFilter";

import { FilterContentContainer } from "./styles";

const ContactLimitResultsFilter = ({
    filter: { options },
    value,
    onFilterUpdate,
}: IFilterViewBaseProps<FindContactLimitResultsFilter>): ReactElement | null => {
    const handleChange = (contactsCount?: number) => {
        if (contactsCount !== undefined) {
            onFilterUpdate({ contactsCount });
            return;
        }

        onFilterUpdate();
    };

    return (
        <FilterContentContainer>
            <ContactsPerCompanyLimitInput
                value={value?.contactsCount}
                defaultPlaceholder={options}
                onChange={handleChange}
            />
        </FilterContentContainer>
    );
};

export default ContactLimitResultsFilter;
